import { Component, OnInit } from '@angular/core';

import { Organisme } from 'src/app/data/intervenant/models/organisme.model';
import { OrganismesService } from 'src/app/data/intervenant/services/organismes/organismes.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LoaderService } from '../../../core/services/loader/loader.service';

@Component({
    selector: 'app-operateur-organismes',
    templateUrl: './operateur-organismes.component.html',
    styleUrls: ['./operateur-organismes.component.scss'],
    standalone: false
})
export class OperateurOrganismesComponent implements OnInit {
    organismes: Organisme[];
    searchStringInput: string;
    searchString = '';
    searchStringUpdate = new Subject<string>();
    order = {
        property: 'id',
        reverse: false
    };

    constructor(private readonly organismesService: OrganismesService, private readonly loaderService: LoaderService) {
        this.searchStringUpdate.pipe(debounceTime(200), distinctUntilChanged()).subscribe(value => {
            this.searchString = value;
        });
    }

    ngOnInit() {
        this.organismesService
            .getOrganismes()
            .pipe(this.loaderService.operator())
            .subscribe(organismes => {
                this.organismes = organismes;
            });
    }

    formatPhoneNumber(phoneNumber: string): string {
        if (!phoneNumber) {
            return '';
        }

        // Supprime tous les caractères non numériques
        const cleaned = phoneNumber.replace(/\D/g, '');

        // Ajoute un espace tous les deux chiffres
        return cleaned.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
    }

    setOrder(property: string) {
        if (property) {
            if (property === this.order.property) {
                this.order.reverse = !this.order.reverse;
            } else {
                this.order = {
                    property,
                    reverse: false
                };
            }
        }
    }

    getIcon(property: string) {
        if (property === this.order.property) {
            return this.order.reverse ? 'sort-down' : 'sort-up';
        } else {
            return 'sort';
        }
    }
}
